import PropTypes from 'prop-types'
import React from 'react'

import { BAR_SIZE } from './constants'

const LabelContent = ({ height, index, value, width, x, y }) => {
  const { comparedLabel, currentLabel } = value

  if (!currentLabel && !comparedLabel) {
    return null
  }

  return (
    <g key={index}>
      <text
        className="label-content"
        textAnchor="left"
        transform={`rotate(-90, ${x + width + BAR_SIZE / 2}, ${height + y - 5})`}
        x={x + width + BAR_SIZE / 2}
        y={height + y - 5}
      >
        {currentLabel} / {comparedLabel}
      </text>
    </g>
  )
}

LabelContent.propTypes = {
  height: PropTypes.number,
  index: PropTypes.number,
  value: PropTypes.shape({
    comparedLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currentLabel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  width: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
}

export default LabelContent
